import { render, staticRenderFns } from "./expert_review_detail.vue?vue&type=template&id=46961b0e&scoped=true"
import script from "./expert_review_detail.vue?vue&type=script&lang=js"
export * from "./expert_review_detail.vue?vue&type=script&lang=js"
import style0 from "./expert_review_detail.vue?vue&type=style&index=0&id=46961b0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46961b0e",
  null
  
)

export default component.exports